class BMICalculator extends BaseCalculator {
  constructor(formulas) {
    super(formulas);

    this.result = {
      bmi: 0,
    };
  }

  calculate() {
    const bmiFormula = this.getFormularByType("bmi");
    if (!bmiFormula) {
      this.result.bmi = 0;
      return;
    }

    this.result.bmi = Math.floor(
      eval(this._prepareFormular(bmiFormula.formula))
    );
  }

  valid() {
    const requiredFields = ['weight', 'size', 'age', 'gender'];
    return requiredFields.every(field => {
      const value = this.getValueByTarget(field);
      return value !== null && value !== "";
    });
  }
}
